import React from 'react';
import * as ds from './dataService';
import {
  FormBaseLayout,
  SelectInstallationAreaField,
  SelectInstallationTypeField,
  SelectStandardTemplateMilestoneField,
  SelectSubAreaField,
  StyledTextField
} from 'modules';
import { Typography } from '@mui/material';
import _ from 'lodash';

export type SaveStandardAreaInstallationFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: SaveStandardAreaInstallationFormProps) => {
  const [
    fnSaveStandardAreaInstallationForm,
    { loading }
  ] = ds.useSaveStandardAreaInstallation();
  const form = ds.useFormState(props.id);
  const handleSubmit = async (dat: ds.IFormState) => {
    const input = _.mapValues(dat, (value, key, coll) => {
      if (key === 'milestoneId' && value === '') {
        return null;
      }
      if (value === '') {
        return undefined;
      }
      return value;
    });
    await fnSaveStandardAreaInstallationForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      isLoading={loading}
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
    >
      <StyledTextField.FC
        {...form.genFieldProps('displayName')}
      />
      <SelectInstallationAreaField.FC
        form={form}
        fieldName='areaId'
      />
      <SelectSubAreaField.FC
        form={form}
        fieldName='subAreaId'
      />
      <SelectInstallationTypeField.FC
        form={form}
        fieldName='typeId'
      />
      <SelectStandardTemplateMilestoneField.FC
        form={form}
        fieldName='milestoneId'
      />

    </FormBaseLayout.FC>

  );
};
